import { GAME_ID, REDUX_ACTIONS } from '../../data/constants';
import { parseAndShuffleTraits } from '../../lib/utilityFunctions';

const initialState = {
  hasSelected: false,
  selectedIndex: -1,
  isDiscarding: false,
  choices: [],
};

const inferenceReducer = (state = initialState, { type, gameId, payload }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.INITIALIZE_STANDARD_ITEM:
      return {
        ...state,
        choices: parseAndShuffleTraits(payload.traits),
      };

    case REDUX_ACTIONS.SET_SELECTED_INFERENCE_INDEX:
      return {
        ...state,
        selectedIndex: payload,
      };

    case REDUX_ACTIONS.DISCARD_SELECTED_INFERENCE_CHOICE: {
      const nextChoices = [...state.choices];
      nextChoices[state.selectedIndex].isDiscarded = true;
      return {
        ...state,
        choices: nextChoices,
      };
    }

    case REDUX_ACTIONS.DESELECT_INFERENCE: {
      return {
        ...state,
        selectedIndex: -1,
      };
    }

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...state,
        selectedIndex: -1,
        hasSelected: false,
      };

    case REDUX_ACTIONS.SET_IS_INFERENCE_PANEL_DISCARDING: {
      return {
        ...state,
        isDiscarding: payload.isDiscarding,
      };
    }

    default:
      return state;
  }
};

export default inferenceReducer;
